import { User } from '@/lib/business';

class ContentAccessRequestInfo {
  /**
   *
   * @type {User}
   */
  uploader = null;

  /**
   *
   * @type {[User]}
   */
  siteAdmins = null;

  get adminsList() {
    return (this.siteAdmins || [])
      .map((user) => user.nameAndEmail)
      .join(', ');
  }

  get details() {
    const uploaderInfo = `Uploader: ${this.uploader.nameAndEmail}\n`;
    const admins = `Site Admins: ${this.adminsList}\n`;

    return `${uploaderInfo}\n${admins}`;
  }

  constructor(data) {
    const { uploader, siteAdmins } = data;

    if (uploader) {
      this.uploader = new User(uploader);
    }

    if (siteAdmins) {
      this.siteAdmins = siteAdmins.map(User.factory());
    }
  }
}

export default ContentAccessRequestInfo;
